import React, { useEffect } from "react";
import { useAuth } from "react-uicomp";
import CompWrapper from "../hoc/compWrapper/CompWrapper.hoc";

// IMAGES
import PLACEHOLDER from "../../assets/images/farm.jpg";
import { TitleB } from "../common/title/Title.common";

const ResearchFarmPage = () => {
  const { setHeaderTitle } = useAuth();

  useEffect(() => {
    setHeaderTitle("Research Farm");
  }, [setHeaderTitle]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <CompWrapper>
      <div>
        <div className="mb-5">
          <TitleB title="Research Farm" />
          <p>
            The research farm is situated in 2 different locations viz.,
            Pakhribas Municipality 3, Pakhribas and Pakhribas Municipality 10,
            Chungbang. The two farms are 13 km away from each other. The
            research farm is accessible with the well connecting roads.
            <br /> The research farm have the following features and facilities:
          </p>
          <div className="mt-3 ml-5">
            <ul>
              <li>Water harvesting ponds/ structures,</li>
              <li>Tractors &amp; accessories,</li>
              <li>Sprayers,</li>
              <li>Various farm implements,</li>
              <li>Barbed wire fencing, etc..</li>
            </ul>
          </div>
        </div>
        <img className="image-showcase" width="60%" src={PLACEHOLDER} />
      </div>
    </CompWrapper>
  );
};

export default ResearchFarmPage;
